import { Link } from "react-router-dom";
import TechnologyList from "../../components/TechnologyList";
import { blogData } from "../../data/blogData";
import { projectData } from "../../data/projectData";
import "./home.css";

export function Home() {
    return (
        <main>
            {/* Landing/introduction section */}
            <section className="bg-secondary text-gray-900 h-[80vh]">
                <div className="max-w-5xl h-full mx-auto flex flex-wrap items-center">
                    <div className="basis-full md:basis-1/2">
                        <img
                            src="https://i.imgur.com/SfFiDYh.jpg"
                            alt="Parth Gabani"
                            className="w-[400px] h-[400px] rounded-full"
                        />
                    </div>
                    <div className="basis-full sm:basis-1/2 flex flex-col gap-7 py-6 pl-10">
                        <div className="text-6xl">Hi I’m</div>
                        <div className="text-6xl">Parth Gabani</div>
                        <div className="text-3xl">Frontend Developer</div>
                        <div className="text-xl">
                            I am passionate about learning new technology in web
                            development field.
                        </div>
                    </div>
                </div>
            </section>

            {/* Project section */}
            <section className="bg-primary text-white py-14 px-20 text-center">
                <h1 className="text-4xl font-bold">My Projects</h1>
                <div className="flex flex-wrap gap-10 py-14 text-gray-900">
                    {projectData.map(
                        (project, index) =>
                            index < 3 && (
                                <div
                                    className="basis-0 flex-grow bg-secondary pb-5 flex flex-col"
                                    key={project.displayName}
                                >
                                    <img
                                        src={project.photoUrl}
                                        alt="Project Name"
                                        className="w-full min-h-[200px]"
                                    />
                                    <div className="flex flex-col gap-5 py-5 px-5 h-full">
                                        <p className="text-2xl font-semibold">
                                            {project.displayName}
                                        </p>
                                        <div className="flex gap-5 flex-wrap justify-center items-center ">
                                            <span className="font-semibold">
                                                Tech:
                                            </span>{" "}
                                            <TechnologyList
                                                technologyList={
                                                    project.technology
                                                }
                                            />
                                        </div>
                                        <p>{project.description}</p>
                                        <a
                                            href={project.url}
                                            className="px-7 py-3 bg-primary hover:opacity-80 mt-auto font-semibold text-white rounded-3xl"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            Live demo
                                        </a>
                                    </div>
                                </div>
                            )
                    )}
                </div>
                <Link
                    to="/project"
                    className="px-7 py-3 bg-secondary hover:opacity-80 mt-auto font-semibold text-gray-900 rounded-3xl"
                >
                    Explore more
                </Link>
            </section>

            {/* Blog section */}
            <section className="bg-secondary text-white py-14 px-20 text-center">
                <h1 className="text-4xl font-bold">My blogs</h1>
                <div className="flex flex-wrap gap-10 py-14">
                    {blogData.map((blog) => (
                        <div
                            className="basis-0 flex-grow max-w-[400px] bg-primary pb-5"
                            key={blog.displayName}
                        >
                            <div className="flex flex-col h-full gap-5 py-5 px-5">
                                <p className="text-2xl font-semibold">
                                    {blog.displayName}
                                </p>
                                <p className="mt-auto">{blog.description}</p>
                                <a
                                    href={blog.url}
                                    className="px-7 py-3 bg-secondary mt-auto hover:opacity-80 font-semibold rounded-3xl"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Read more
                                </a>
                            </div>
                        </div>
                    ))}
                </div>
            </section>
        </main>
    );
}
